// extracted by mini-css-extract-plugin
export default {"menu":"menu--MVJXt","pointer":"pointer--pD5T9"};